import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=a7153414&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=ts"
export * from "./Articles.vue?vue&type=script&lang=ts"
import style0 from "./Articles.vue?vue&type=style&index=0&id=a7153414&prod&scoped=true&lang=scss"
import style1 from "./Articles.vue?vue&type=style&index=1&id=a7153414&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7153414",
  null
  
)

export default component.exports